import {Injectable, Injector} from '@angular/core';
import {BaseResourceService} from '@sicapes/core';
import {Observable} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import {HttpHeaders} from "@angular/common/http";

export class IScdocservicos {
    id?: number;

    static fromJson(jsonData: any): IScdocservicos {
        return Object.assign(new IScdocservicos(), jsonData);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ScdocservicosService extends BaseResourceService<IScdocservicos> {

    constructor(protected injector: Injector) {
        super('rest/scdocservicos', injector, IScdocservicos.fromJson);
    }

    public obterDocentes(identificadorRegistrado: string): Observable<any[]> {
        return this.http.get(this.apiPath + `/${identificadorRegistrado}/docentes`)
            .pipe(map(this.jsonDataToResources.bind(this)),
            catchError(this.handleError)
        );
    }

    protected jsonDataToResources(jsonData: any): any[] {
        return jsonData;
    }
}
